// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-17Mucu8I","dbox":"dbox-3DIULOmX"};